import { v4 as uuidv4 } from "uuid";

function DNDSlotmachine({ card, elementStyle, changeSelection, language }) {
  const symbols = card.value.map((value) => value.languages[language]);

  

  return (
    <div
      id="componentContainer"
      data-tour="rpdesigner-step-3"
      style={elementStyle}
      onClick={changeSelection}
    >
      <div
        id="reel"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {Array.from({ length: card.slotCount }).map((_, index) => (
          <ul
            key={index}
            style={{
              listStyleType: "none",
              flex: "1",
              display: "flex",
              padding: "0",
            }}
          >
            <li
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid black",
                borderRadius: "10px",
                boxShadow: "0 0 3px 2px rgb(0 0 0 / 40%) inset",
                margin: "10px",
                width: "100%",
                overflow: "hidden",
              }}
            > 
              <img
                id={`img` + index}
                alt="symbols"
                src={symbols[0]}
                style={{
                  width: "100%",
                  height: "auto",
                  position: "relative",
                  display: "none",
                 
                }}
              />
              <img
                id="placeholderImage"
                src="https://codikett.ams3.cdn.digitaloceanspaces.com/securikett/bandit/RafflePlaceholder.png"
                alt="Placeholder Image"
                style={{
                  width: "100%",
                  height: "auto",
                  position: "relative",
                  
                }}>
              </img>
             
            </li>
          </ul>
        ))}
      </div>
      
      <button
        type="button"
        id="spinbutton"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "auto",
          maxWidth: "90%",
          marginBottom: "5px",
          fontWeight: "500",
          fontSize: card.fontSize + "px",
          lineHeight: "1.75",
          letterSpacing: "0.02857em",
          minWidth: "64px",
          padding: "6px 16px",
          borderRadius: "4px",
          color: "#fff",
          backgroundColor: card.buttonColor,
          border: "0",
          cursor: "pointer",
        }}
      >
        START
      </button>
      <div id="winMessage" style={{ display: "none" }}>
        <p></p>
      
      </div>
      
      <div id="recipient" style={{ display: "none" }}>
        {card.value[1].languages[language]}
      </div>


      <input
        readOnly
        id="displayDefault"
        style={{ display: "none" }}
        value={card.displayDefault}
      />
      <input
        readOnly
        id="displaySuccess"
        style={{ display: "none" }}
        value={card.displaySuccess}
      />
      <input
        readOnly
        id="displayError"
        style={{ display: "none" }}
        value={card.displayError}
      />
      <input
        readOnly
        id="slotcount"
        style={{ display: "none" }}
        value={card.slotCount}
      />
      <input
        readOnly
        id="recipientEmail"
        style={{ display: "none" }}
        value={card.recipientEmail}
      />
      <input
        readOnly
        id="bodyText"
        style={{ display: "none" }}
        value={card.bodyText}
      />
      <input
        readOnly
        id="subjectText"
        style={{ display: "none" }}
        value={ (card.value.find(({ name }) => name === 'subjectText') || { languages: { en: '' } }).languages['en']}
      />
      {card.value
        .filter(value => value.name === "image")
        .map((value, index) => (
          <input
            readOnly
            id={`spinimage${index}`}
            style={{ display: "none" }}
            value={value.languages[language]}
          />
      ))}
    </div>
  );
}

export default DNDSlotmachine;
